import React from "react"
import CommissionSlabs from "./CommissionSlab";
import { PermisionDenied } from "views/pages/manage/common/commonComponents";
import { useGetPermissions } from "layouts/customHook";

const CommissionSlabWrapper=()=>{
      const userPermissions = useGetPermissions('commissionSlab');

    return userPermissions ? (
        <CommissionSlabs
            userPermissions={userPermissions}
        />
    ) : (
        <PermisionDenied />
    );
}

export default CommissionSlabWrapper